import * as actionTypes from '../../constants/ActionTypes/FAQ';

const initialState = {
    'FAQTopCategories': {},
    'loading': false,
    'error': false
  }

  const FAQTopCategories = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.FAQ_FETCH_CATEGORY_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.FAQ_FETCH_CATEGORY_SUCCESS:
            return {
                ...state,
                FAQTopCategories: action.FAQTopCategories,
                loading: false
            }
        case actionTypes.FAQ_FETCH_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message
            }
        default:
            return {...state};
    }

}

export default FAQTopCategories;